<template>
  <div>
    <template v-for="gateway in gateways">
      <v-layout row wrap class="align-center mb-4" :key="gateway.method">
        <v-flex xs12>
          <advice color="primary">
            <p
              v-html="gateway.title"
              class="font-weight-bold title primary--text"
            ></p>
            <p
              v-html="gateway.subtitle.replace(new RegExp('\n', 'g'), '<br/>')"
              class="subheading grey--text grey--lighten-1"
            ></p>

            <v-checkbox
              :label="$t('global.buy.hours.remember')"
              v-model="rememberCard"
              v-if="gateway.cards"
              :value="true"
            ></v-checkbox>
          </advice>
        </v-flex>

        <v-flex class="pr-3" xs12>
          <v-layout row wrap class="align-end">
            <template v-if="gateway.cards">
              <v-flex xs12>
                <v-btn
                  color="accent"
                  round
                  outline
                  class="initialize mb-4"
                  @click="preparePayment(gateway.method, null)"
                  :disabled="isPaying"
                >
                  {{ $t('global.buy.new.card') }}
                </v-btn>
              </v-flex>
              <v-flex v-if="creditCards.length > 0">
                <v-layout row wrap>
                  <v-flex xs10 class="px-2">
                    <span class="caption grey--text text--darken-1">
                      {{ $t('payment.advice.oneClick') }}
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <template v-for="cc in creditCards">
                    <v-flex :key="cc.id">
                      <v-btn
                        color="primary"
                        round
                        outline
                        :disabled="isPaying"
                        @click="preparePayment(defaultGateway.method, cc.id)"
                        >{{ cc.alias }}
                      </v-btn>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>
            </template>

            <template v-else>
              <v-btn
                color="accent"
                round
                outline
                class="initialize mb-4"
                @click="preparePayment(gateway.method, null)"
                :disabled="isPaying"
              >
                {{ $t('global.button.buy') }}
              </v-btn>
              <!-- <v-btn
                v-else
                id="payButtonId"
                color="accent"
                round
                outline
                class="initialize mb-4"
                :disabled="isPaying"
              >
                {{ $t('global.button.buy') }}
              </v-btn> -->
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>

    <!-- <iframe id="myIframe"> </iframe> -->

    <form
      ref="formBank"
      method="POST"
      :action="paymentServiceForm.endpoint"
      v-show="true"
    >
      <!-- <input
        name="HPP_POST_DIMENSIONS"
        value="https://api-pre.wesmartpark.com"
      />
      <input name="HPP_POST_RESPONSE" value="https://api-pre.wesmartpark.com" /> -->
      <template v-for="data in paymentServiceForm.data">
        <input
          :key="data.key"
          type="hidden"
          :value="data.value"
          :name="data.key"
        />
      </template>
    </form>
  </div>
</template>

<script>
import productService from '@/services/productService';
import subscriptionService from '@/services/subscriptionService';
import creditCardService from '@/services/creditCardService';
import manageErrorService from '@/services/manageErrorService';
import oLocalStorage from '@/services/objectLocalStorage';
import store from '@/store';
import keys from '@/store/keys';
import _ from 'lodash';
import Advice from '@/components/commons/Advice';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'PaymentInternal',
  components: {
    [Advice.name]: Advice,
  },
  props: {
    parking: {
      type: Object,
    },
    product: {
      type: Object,
      default: null,
    },
    subscription: {
      type: Object,
      default: null,
    },
    couponCode: {
      type: [Object, String],
      default: null,
    },
    openAutomatically: {
      type: Boolean,
      deafult: false,
    },
  },
  computed: {
    isLogged() {
      return store.state.isLogged;
    },
  },
  data() {
    return {
      isPaying: false,
      gateways: [],
      creditCards: [],
      rememberCard: true,
      paymentServiceForm: {
        endpoint: '',
        data: [],
      },
    };
  },
  async mounted() {
    if (this.isLogged) {
      await this.loadPaymentGateways();
      this.loadCreditCards();

      // const exists = _.find(this.gateways, function(o) {
      //   return o.method === 'addonPayments';
      // });

      // if (typeof exists !== 'undefined') {
      //   let addonPaymentResult = {};
      //   if (this.product !== null) {
      //     const resp = await productService.buyAddonPayments({
      //       city: store.state.citySelected.code,
      //       rememberCard: this.rememberCard,
      //       productId: this.product.id,
      //       couponCode: this.couponCode,
      //       cardId: -1
      //     });
      //     addonPaymentResult = resp.data;
      //   } else if (this.subscription !== null) {
      //     const resp = await subscriptionService.buyAddonPayments({
      //       subscriptionId: this.subscription.id,
      //       type: this.subscription.type,
      //       city: store.state.citySelected.code,
      //       cardId: -1,
      //       rememberCard: this.rememberCard
      //     });
      //     addonPaymentResult = resp.data;
      //   }

      //   const hppJson = JSON.parse(addonPaymentResult.hppJson);
      //   // hppJson.HPP_POST_RESPONSE = addonPaymentResult.urlReturn;
      //   // hppJson.HPP_POST_RESPONSE = addonPaymentResult.urlReturn;
      //   // eslint-disable-next-line no-undef
      //   RealexHpp.setHppUrl(addonPaymentResult.hppUrl);
      //   // eslint-disable-next-line no-undef
      //   RealexHpp.redirect.init(
      //     'payButtonId',
      //     addonPaymentResult.urlReturn,
      //     hppJson
      //   );
      // }
    }
  },
  methods: {
    async loadCreditCards() {
      let results = await creditCardService.list();
      if (results.error) {
        return;
      }
      this.creditCards = results.data;
    },
    async loadPaymentGateways() {
      let results = await productService.gateways({});
      if (results.error) {
        return;
      }
      this.gateways = _.sortBy(results.data, [
        function (o) {
          return o.cards;
        },
      ]);

      this.defaultGateway = _.find(this.gateways, (itg) => itg.cards);

      if (this.openAutomatically) {
        this.preparePayment(this.defaultGateway.method, null);
      }
    },

    async preparePayment(method, cardId) {
      this.isPaying = true;

      let params = {
        city: store.state.citySelected.code,
        cardId: cardId,
        rememberCard: this.rememberCard,
      };

      if (this.subscription === null) {
        store.commit('UPDATE_BALANCE_BEFORE_BUYING', {
          balanceBeforeBuying: store.state.user.balance.total,
        });
        params.productId = this.product.id;
        params.couponCode = this.couponCode;

        this.$mam.actionBuy(params);

        await this.pay(method, params);
        return;
      }

      params.subscriptionId = this.subscription.id;
      params.type = this.subscription.type;

      this.$mam.actionBuy(params);

      await this.paySubscription(method, params);
    },

    async pay(method, params) {
      let results = await productService.buy(method, params);

      if (results.error) {
        this.isPaying = false;
        manageErrorService.handle(results.data);
        return;
      }

      if (typeof results.data.result !== 'undefined') {
        this.paymentSucessRememberCard(results.data.result);

        return;
      }
      this.fillForm(results.data, method);
    },

    async paySubscription(method, params) {
      let results = await subscriptionService.buy(method, params);
      if (results.error) {
        this.isPaying = false;
        manageErrorService.handle(results.data);
        return;
      }

      if (typeof this.parking !== 'undefined') {
        oLocalStorage.set(keys.lastParkingAliasBoughtSubscription, {
          alias: this.$route.params.alias,
        });
      }

      if (typeof results.data.result !== 'undefined') {
        this.paymentSucessRememberCard(results.data.result);
        return;
      }

      this.fillForm(results.data, method);
    },

    fillForm(paymentBrokerData, method) {
      if (method === 'addonPayments') {
        this.paymentServiceForm.endpoint = paymentBrokerData.hppUrl;
        const hppJsonData = JSON.parse(paymentBrokerData.hppJson);
        _.forOwn(hppJsonData, (v, k) => {
          this.paymentServiceForm.data.push({ key: k, value: v });
        });
        // this.paymentServiceForm.data.push({
        //   key: 'HPP_POST_RESPONSE',
        //   value: paymentBrokerData.urlReturn
        // });

        this.$nextTick(() => {
          this.$refs.formBank.submit();
        });

        return;
      }

      this.paymentServiceForm.endpoint = paymentBrokerData.endpoint;

      _.forOwn(paymentBrokerData, (v, k) => {
        if (k !== 'endpoint') {
          this.paymentServiceForm.data.push({ key: k, value: v });
        }
      });

      this.$nextTick(() => {
        this.$refs.formBank.submit();
      });
    },

    paymentSucessRememberCard(data) {
      let tpvResult = this.getQueryResultAsObject(data);

      if (typeof this.parking === 'undefined') {
        this.$router.replace(
          {
            path: this.$i18n.t('urlBuy'),
            query: { ok: tpvResult.TPV, paymentId: tpvResult.payment },
          },
          () => {
            this.$router.go();
          }
        );
      } else {
        let params = {
          ok: tpvResult.TPV,
        };

        if (typeof tpvResult.subscription !== 'undefined') {
          params.subscription = tpvResult.subscription;
        }

        if (typeof tpvResult.payment !== 'undefined') {
          params.payment = tpvResult.payment;
        }

        this.$router.replace(
          {
            path: this.$i18n.t('urlParkingDetail', {
              alias: this.$route.params.alias,
            }),
            query: params,
          },
          () => {
            this.$router.go();
          }
        );

        // this.$router.replace({ path: this.$i18n.t('urlParkingDetail', { alias: this.$route.params.alias }), query: { ok: tpvResult.TPV, paymentId: tpvResult.payment } }, () => {
      }
    },

    getQueryResultAsObject(data) {
      const query = data.substr(data.indexOf('?') + 1);
      let vars = query.split('&');
      let result = {};
      let tmp = '';
      vars.forEach(function (v) {
        tmp = v.split('=');
        if (tmp.length === 2) {
          result[tmp[0]] = tmp[1];
        }
      });
      return result;
    },

    closeModalAddonPayment() {
      EventBus.$emit(keys.eventOnCloseModal, {});
    },
  },
};
</script>
